import $foreign from "./foreign.cjs";
var _caseJson = $foreign._caseJson;
var _compare = $foreign._compare;
var fromArray = $foreign.fromArray;
var fromBoolean = $foreign.fromBoolean;
var fromNumber = $foreign.fromNumber;
var fromObject = $foreign.fromObject;
var fromString = $foreign.fromString;
var jsonNull = $foreign.jsonNull;
var stringify = $foreign.stringify;
var stringifyWithIndent = $foreign.stringifyWithIndent;
export { _caseJson, _compare, fromArray, fromBoolean, fromNumber, fromObject, fromString, jsonNull, stringify, stringifyWithIndent };
